import { Button, Datepicker, InputField } from "@/common/components";
import { PrivateContext } from "@/routes/PrivateRoute";
import { useState, useContext, useLocation } from "@/common/hooks";
import labels from "@/labels/labels";
import { validate } from "@/utils/Validations";

export default function ProductDetails() {
  const location = useLocation();
  const { productData } = location.state || {};
  const { debounceErrors } = useContext(PrivateContext);

  const [productName, setProductName] = useState(productData.name);
  const [productDesc, setProductDesc] = useState(productData.description);
  const [productType, setProductType] = useState(productData.productType);
  const [productDistribution, setProductDistribution] = useState();
  const [activeDate, setActiveDate] = useState(productData.activeDt);
  const [closeAt, setCloseAt] = useState(productData.closedDt);
  const [reOpenAt, setReopenAt] = useState(productData.reopenDt);
  const [newOwnerShipCloseDate, setNewOwnerShipCloseDate] = useState(
    productData.newInvestorCloseDt
  );
  const [newPurchaseCloseDate, setNewPurchaseCloseDate] = useState(
    productData.newPurchaseCloseDt
  );

  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});

  const cancel = () => {};
  const checkData = () => {};

  const checkDisabled = () => {
    return Object.values(errors).some((val) => val);
  };

  return (
    <section className="productDetailsSection ">
      <div className="d-flex justify-content-center align-items-center primary-color productDetailTitle">
        {labels?.productDetail?.productDetails}
      </div>
      <div
        className="productDetailFormSection"
        style={{ paddingLeft: "20%", paddingRight: "20%" }}
      >
        <div className="mb-3 mt-3">
          <label>{labels?.productDetail?.externalProductId}</label>: 1590234
        </div>
        <div className="productDetailSection1">
          <div className="mb-3">
            <label>{labels?.productDetail?.productName}</label>
            <InputField
              id="productName"
              value={productName}
              change={async (e) => {
                setProductName(e);
              }}
              touched={touched.productName}
              error={errors.productName}
              touch={() => setTouched({ ...touched, productName: true })}
              wrapperClassName="mb-4"
              blur={async (e) => {
                setProductName(e);
                debounceErrors(
                  {
                    ...errors,
                    productName: await validate(e, "productName"),
                  },
                  setErrors
                );
              }}
            />
            {/* {productNameError} */}
          </div>
          <div className="mb-3">
            <label>{labels?.productDetail?.productDescription}</label>
            <InputField
              id="productDesc"
              value={productDesc}
              change={async (e) => {
                setProductDesc(e);
              }}
              touched={touched.productDesc}
              error={errors.productDesc}
              touch={() => setTouched({ ...touched, productDesc: true })}
              wrapperClassName="mb-4"
              blur={async (e) => {
                setProductDesc(e);
                debounceErrors(
                  {
                    ...errors,
                    productDesc: await validate(e, "productDesc"),
                  },
                  setErrors
                );
              }}
            />
          </div>
          <div className="mb-3">
            <label>{labels?.productDetail?.productType}</label>
            <InputField
              id="productType"
              value={productType}
              change={async (e) => {
                setProductType(e);
              }}
              touched={touched.productType}
              error={errors.productType}
              touch={() => setTouched({ ...touched, productType: true })}
              wrapperClassName="mb-4"
              blur={async (e) => {
                setProductType(e);
                debounceErrors(
                  {
                    ...errors,
                    productType: await validate(e, "productType"),
                  },
                  setErrors
                );
              }}
            />
          </div>
          <div className="mb-3">
            <label>{labels?.productDetail?.productDistribution}</label>
            <InputField
              id="productDistribution"
              value={productDistribution}
              change={async (e) => {
                setProductDistribution(e);
              }}
              touched={touched.productDistribution}
              error={errors.productDistribution}
              touch={() =>
                setTouched({ ...touched, productDistribution: true })
              }
              wrapperClassName="mb-4"
              blur={async (e) => {
                setProductDistribution(e);
                debounceErrors(
                  {
                    ...errors,
                    productDistribution: await validate(
                      e,
                      "productDistribution"
                    ),
                  },
                  setErrors
                );
              }}
            />
          </div>
        </div>
        <div className="productDetailSection2">
          <div className="productDetailHeader">
            <label>{labels?.productDetail?.productActivation}</label>
          </div>
          <div className="mb-3 mt-3">
            <Datepicker
              id="secondSecurityQuestion"
              label={labels?.productDetail?.activeDate}
              value={activeDate}
              change={async (e) => {
                setActiveDate(e);
              }}
              touched={touched.activeDate}
              error={errors.activeDate}
              touch={() => setTouched({ ...touched, activeDate: true })}
              wrapperClassName="mb-4 w-30"
              blur={async (e) => {
                setActiveDate(e);
                debounceErrors(
                  {
                    ...errors,
                    activeDate: await validate(e, "activeDate"),
                  },
                  setErrors
                );
              }}
            />
          </div>
          <div className="mb-3">
            <Datepicker
              id="closeAt"
              label={labels?.productDetail?.closeAt}
              value={closeAt}
              change={async (e) => {
                setCloseAt(e);
              }}
              touched={touched.closeAt}
              error={errors.closeAt}
              touch={() => setTouched({ ...touched, closeAt: true })}
              wrapperClassName="mb-4 w-30"
              blur={async (e) => {
                setCloseAt(e);
                debounceErrors(
                  {
                    ...errors,
                    closeAt: await validate(e, "closeAt"),
                  },
                  setErrors
                );
              }}
            />
          </div>
          <div className="mb-3">
            <Datepicker
              id="secondSecurityQuestion"
              label={labels?.productDetail?.reopenAt}
              value={reOpenAt}
              change={async (e) => {
                setReopenAt(e);
              }}
              touched={touched.reOpenAt}
              error={errors.reOpenAt}
              touch={() => setTouched({ ...touched, reOpenAt: true })}
              wrapperClassName="mb-4 w-30"
              blur={async (e) => {
                setReopenAt(e);
                debounceErrors(
                  {
                    ...errors,
                    reOpenAt: await validate(e, "reOpenAt"),
                  },
                  setErrors
                );
              }}
            />
          </div>
        </div>

        <div className="productDetailSection3">
          <div className="productDetailHeader">
            <label>
              {labels?.productDetail?.setUpCompletionDate}: 01/03/24
            </label>
          </div>
          <div className="mb-3 mt-3">
            <Datepicker
              id="newOwnerShipCloseDate"
              label={labels?.productDetail?.newOwnerShipCloseDate}
              value={newOwnerShipCloseDate}
              change={async (e) => {
                setNewOwnerShipCloseDate(e);
              }}
              touched={touched.newOwnerShipCloseDate}
              error={errors.newOwnerShipCloseDate}
              touch={() =>
                setTouched({ ...touched, newOwnerShipCloseDate: true })
              }
              wrapperClassName="mb-4 w-30"
              blur={async (e) => {
                setNewOwnerShipCloseDate(e);
                debounceErrors(
                  {
                    ...errors,
                    newOwnerShipCloseDate: await validate(
                      e,
                      "newOwnerShipCloseDate"
                    ),
                  },
                  setErrors
                );
              }}
            />
          </div>
          <div className="mb-3">
            <Datepicker
              id="secondSecurityQuestion"
              label={labels?.productDetail?.newPurchaseCloseDate}
              value={newPurchaseCloseDate}
              change={async (e) => {
                setNewPurchaseCloseDate(e);
              }}
              touched={touched.newPurchaseCloseDate}
              error={errors.newPurchaseCloseDate}
              touch={() =>
                setTouched({ ...touched, newPurchaseCloseDate: true })
              }
              wrapperClassName="mb-4 w-30"
              blur={async (e) => {
                setNewPurchaseCloseDate(e);
                debounceErrors(
                  {
                    ...errors,
                    newPurchaseCloseDate: await validate(
                      e,
                      "newPurchaseCloseDate"
                    ),
                  },
                  setErrors
                );
              }}
            />
          </div>
        </div>
      </div>
      <div className="buttonSection d-flex justify-content-between pb-4 ps-5 pe-5">
        <Button
          id="cancel"
          text={labels?.productDetail?.cancel}
          wrapperClassName="mb-2 w-15"
          type="secondary"
          click={cancel}
        />
        <Button
          id="save"
          wrapperClassName="mb-2 w-15"
          text={labels?.productDetail?.next}
          click={checkData}
          disabled={checkDisabled()}
        />
      </div>
    </section>
  );
}
